import { DashboardOrderDetailsResponse } from "@/shared/api";
import { Flex } from "@radix-ui/themes";
import { createColumnHelper } from "@tanstack/react-table";
import { useState, useMemo } from "react";
import { DataTable } from "./data-table";
import { DialogTable } from "./dialog-table";

type PinBasedAnomalyProps = {
  data: DashboardOrderDetailsResponse["result"]["pin_based_anomaly"];
};

export function PinBasedAnomaly({ data }: PinBasedAnomalyProps) {
  const [columnHelper] = useState(() => createColumnHelper<any>());

  const columns = useMemo(() => {
    const journeyIds = Object.keys(data.indicator_group_per_journey_id);

    if (journeyIds.length === 0) return [];

    const firstJourneyId = journeyIds[0];
    const firstJourneyIdData =
      data.indicator_group_per_journey_id[firstJourneyId];
    const columnKeys = Object.keys(firstJourneyIdData);

    columnKeys.unshift("journey_id");

    return columnKeys.map((key) => {
      if (key === "track_anomaly_indicators")
        return columnHelper.accessor(key, {
          header: () => (
            <span className="capitalize">{key.split("_").join(" ")}</span>
          ),
          cell: ({ getValue }) => {
            return <DialogTable data={getValue()} />;
          },
        });

      return columnHelper.accessor(key, {
        header: () => (
          <span className="capitalize">{key.split("_").join(" ")}</span>
        ),
      });
    });
  }, [data, columnHelper]);

  const tableData = useMemo(() => {
    return Object.keys(data.indicator_group_per_journey_id).map(
      (journeyId) => ({
        ...data.indicator_group_per_journey_id[journeyId],
        journey_id: journeyId,
      })
    );
  }, [data.indicator_group_per_journey_id]);

  return (
    <Flex direction="column" className="h-[calc(100dvh-11rem)]">
      <DataTable
        loading={false}
        isSuccess={true}
        totalCount={tableData.length}
        data={tableData}
        columns={columns}
        title="Pin-Based Anomaly"
        emptyTitle="Empty"
        emptyDescription={""}
      />
    </Flex>
  );
}
